import { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { SketchfabIframe } from '../SketchfabIframe/SketchfabIframe'
import type { SketchfabSlideProps } from './SketchfabSlide.types'

export const SketchfabSlide = ({
  slide,
  isActive,
  isNext,
  isPrev,
}: SketchfabSlideProps): JSX.Element | null => {
  const [is3DModelInitialized, setIs3DModelInitialized] = useState(false)

  useEffect(() => {
    if (isActive) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setIs3DModelInitialized(true)
    }
  }, [isActive])

  return is3DModelInitialized ? (
    <ErrorBoundary fallback="media unavailable">
      <SketchfabIframe
        isNext={isNext}
        isPrev={isPrev}
        isActive={isActive}
        slide={slide}
      />
    </ErrorBoundary>
  ) : null
}
